import { defineMessages } from "react-intl";

const messages = defineMessages({
  category: {
    id: "ccXLVi",
    defaultMessage: "Category",
  },
  collection: {
    id: "phAZoj",
    defaultMessage: "Collection",
  },
  collectionPublished: {
    id: "lL3YJO",
    defaultMessage: "Published",
    description: "collection",
  },
  collectionUnpublished: {
    id: "M1uijW",
    defaultMessage: "Not Published",
    description: "collection",
  },
  createCategory: {
    id: "CjSRT1",
    defaultMessage: "Create Category",
    description: "button",
  },
  createCollection: {
    id: "VdDcxc",
    defaultMessage: "Create Collection",
    description: "button",
  },
  createCustomer: {
    id: "QooeI/",
    defaultMessage: "Create Customer",
    description: "button",
  },
  createOrder: {
    id: "cfQf0w",
    defaultMessage: "Create Order",
    description: "button",
  },
  createPermissionGroup: {
    id: "V1mqpZ",
    defaultMessage: "Create Permission Group",
    description: "button",
  },
  createProduct: {
    id: "JFmOfi",
    defaultMessage: "Create Product",
    description: "button",
  },
  createVoucher: {
    id: "y9cvqE",
    defaultMessage: "Create Voucher",
    description: "button",
  },
  customerWithName: {
    id: "1gzck6",
    defaultMessage: "{firstName} {lastName}",
  },
  goToOrder: {
    id: "IyHQr0",
    defaultMessage: "Go to order #{orderNumber}",
    description: "navigator action",
  },
  helpCatalogMode: {
    id: "kbkjEc",
    defaultMessage: "Search in Catalog",
    description: "navigator catalog mode description",
  },
  helpCommandsMode: {
    id: "3TlhJS",
    defaultMessage: "Search Command",
    description: "navigator command mode description",
  },
  helpCustomersMode: {
    id: "DHBlFi",
    defaultMessage: "Search Customers",
    description: "navigator customer mode description",
  },
  helpDefaultMode: {
    id: "Xel9C+",
    defaultMessage: "Search Views and Actions",
    description: "navigator default mode description",
  },
  helpMode: {
    id: "iAvKNf",
    defaultMessage: "Display Help",
    description: "navigator help mode description",
  },
  helpOrdersMode: {
    id: "usSkzP",
    defaultMessage: "Search Orders",
    description: "navigator order mode description",
  },
  noResults: {
    id: "k8bltk",
    defaultMessage: "No Results",
  },
  product: {
    id: "x/ZVlU",
    defaultMessage: "Product",
  },
});

export default messages;
